import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import PropTypes from "prop-types";
import SortableTicket from "../sortableTicket/SortableTicket";

function SortableTicketList({ tickets, onReorder, handleEdit, handleDelete }) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = tickets.findIndex((t) => t.id === active.id);
      const newIndex = tickets.findIndex((t) => t.id === over.id);
      onReorder(oldIndex, newIndex);
    }
  }

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={tickets.map((t) => t.id)} strategy={rectSortingStrategy}>
        {tickets.map((ticket, index) => (
          <SortableTicket
            key={ticket.id}
            ticket={ticket}
            editable
            deletable={ticket.isNew}
            handleDelete={() => handleDelete(index)}
            handleEdit={() => handleEdit(index)}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
}

SortableTicketList.propTypes = {
  tickets: PropTypes.array.isRequired,
  onReorder: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default SortableTicketList;
